import React, { Component } from 'react';
//import { Link } from 'react-router-dom';
//import './App.css';
import firebase from './../Firestore'

class CategoriaNombre extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categoriaNombre: ""
    };
     //console.log("this.props.categoriaID en constr", this.props.categoriaID)

    this.consultoDB = false;

  }


levantarCategoriaDB(categoriaID){
  //console.log("CONSULTA DB" )
  var currentComponent = this
  var db = firebase.firestore();
  var docRef = db.collection("categoria").doc(categoriaID);

  docRef.get().then(function(doc) {
      if (doc.exists) {
          //console.log("Document data:", doc.data());
          currentComponent.setState({
            categoriaNombre: doc.data().nombre
          }) ;


          //currentComponent.categoriaNombre = doc.data().nombre

      } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
      }

  }).catch(function(error) {
      console.log("Error getting document:", error);
  });
  //this.test = "test 2"
  //console.log("test", this.test)
  this.consultoDB = true;
}

componentDidUpdate(){
  if(!this.consultoDB) this.levantarCategoriaDB(this.props.categoriaID);
  //console.log("did update ", this.props.categoriaID )
}

  async componentDidMount() {
    //var categoriaID = await this.props.categoriaID;
    if(this.props.categoriaID !== undefined) this.levantarCategoriaDB(this.props.categoriaID)


  }

  render() {
    return (


      <span>{this.state.categoriaNombre}</span>



    );
  }
}

export default CategoriaNombre;
